// extracted by mini-css-extract-plugin
module.exports = {"mulitpleDropdown":"tasksBoard_mulitpleDropdown__15QLL","boardWrapper":"tasksBoard_boardWrapper__2rxj3","loaderWrapper":"tasksBoard_loaderWrapper__1XbfH"};